import React from "react";
import { ScenariosData } from "../../../data/scenarios.data";

interface Props {
  car: any;
  scenario: any;
  reset: boolean;
  setScenario: (value: any) => void;
  setReset: (value: boolean) => void;
}

const BottombarScenario: React.FC<Props> = ({ car, scenario, reset, setScenario, setReset}) => {
  
  const [scenarioList, setScenarioList] = React.useState<any>([]);

  React.useEffect(() => {
    if(car){
      const scenarios: any = ScenariosData();
      if(scenarios){
        const scenario_list: any = [];
        for (const scenario of scenarios) {
          if (scenario.active)
            scenario_list.push(scenario);
        }
        setScenarioList(scenario_list);
        if(reset === true){
          setScenario(scenario_list[0]);
          setReset(false);
        }
      }
    }
  }, [car, reset, setScenario, setReset]);

  return (
    <div className="bottombar-scenario">
      
        <div className='bottombar-scenario-title'>Escenarios</div>
        <div className='bottombar-scenario-selection'>
          {
            (scenarioList as {}[]).map((scenarioItem: any, index: number) =>
              <div key={index} className={`bottombar-scenario-subcontainer ${scenarioItem.id === scenario.id ? 'selected':''}`} onClick={() => {if(scenarioItem.interactable === true){setScenario(scenarioItem)} }}>
                <div className={`bottombar-scenario-element ${scenarioItem.id === scenario.id ? 'selected':''}`}>
                  <div className={`bottombar-scenario-text ${scenarioItem.id === scenario.id ? 'selected':''}`}>{scenarioItem.name}</div>
                </div>
              </div>
            )
          }
        </div>
      
    </div>
  );
};

export default BottombarScenario;